import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useMediaQuery, useTheme } from '@mui/material';

export const TablePaginationLabelRowsPerPage = () => {
	const theme = useTheme();
	const desktop = useMediaQuery(theme.breakpoints.up('md'));

	return <>{desktop ? <FormattedMessage id="pagination.rowsPerPage" defaultMessage="Na stránku" /> : ''}</>;
};
